export class CheckGroupConfig {
    url?: string;
    params?: object;
    data?: any[];
    constructor() {
        this.url = '';
        this.params = {};
        this.data = [];
    }
}
